export const settings = {
  baseUrl: 'https://calendar.alfalahmanzil.net/api',
  imageUriPath: 'https://calendar.alfalahmanzil.net/uploads/',
  MongodbAppName: 'alfalah-calendar-app',
};
